import React, { useState } from "react";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import Image from "../../Components/Reusable/Image";
// import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
// import ConfirmationModal from "../../Components/modal/ConfirmationModal";
// import { ConfirmationModalTheme } from "../../Utils/Enums";
// import AuthService from "../../Services/AuthService";
import { useNavigate } from "react-router-dom";
// import RoutesPath from "../../Utils/RoutesPath";
import CustomTextFieldTwo from "../../Components/Reusable/CustomTextFieldTwo";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import Sidebar from "../StudentSidebar/Sidebar";
import StudentNavbar from "../StudentNavbar/StudentNavbar";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import { toast } from "react-toastify";
import RoutesPath from "../../Utils/RoutesPath";

const ChangePassword = ({ show }) => {

  const navigate = useNavigate();
  const schema = yup.object().shape({
    currentPassword: validationRegex.currentPassword,
    newPassword: validationRegex.newPassword,
    confirmPassword: validationRegex.confirmPassword,
  });

  const { register: registerUpdate, handleSubmit: handleSubmitUpdate, formState: { errors: errorsUpdate } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
  });

  const changePassword = async (data) => {
    const { currentPassword, newPassword, confirmPassword } = data;
    try {
      await StudentDashboardServices.changePassword(
        currentPassword,
        newPassword,
        confirmPassword,
      );
      toast.success("Your password changed successfully");
      navigate(RoutesPath.dashboardstudent); // Redirect to the packages page
    } catch (error) {
      handleApiErrors(error);
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="mainLayout-content">
        <StudentNavbar />
        <div className="main_content contentSection scroll_bar">
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="black sub-large-text-one fw-700 mb-0">Change Password</h1>
          </div>
          <form onSubmit={handleSubmitUpdate(changePassword)}>

            <div className="row profile_inputs w-100">
              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="Current Password"
                  placeholder="Enter Current Password"
                  inputType={InputType.password}
                  id="currentPassword"
                  name="currentPassword"
                  showError={errorsUpdate?.currentPassword}
                  errorMessage={errorsUpdate?.currentPassword?.message}
                  register={registerUpdate}
                  labelClass="TextInput"
                  additionalClasses="profile_edit"
                  showMandatory={true}
                />
              </div>

              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="New Password"
                  additionalClasses="profile_edit"
                  labelClass="TextInput"
                  inputType={InputType.password}
                  id="newPassword"
                  name="newPassword"
                  placeholder="Enter New Password"
                  showError={errorsUpdate?.newPassword}
                  errorMessage={errorsUpdate?.newPassword?.message}
                  register={registerUpdate}
                  showMandatory={true}
                />
              </div>

              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="Confirm Password"
                  inputType={InputType.password}
                  additionalClasses="profile_edit"
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Enter Confirm Password"
                  showError={errorsUpdate?.confirmPassword}
                  errorMessage={errorsUpdate?.confirmPassword?.message}
                  register={registerUpdate}
                  labelClass="TextInput"
                  showMandatory={true}
                />
              </div>
              <div className="d-flex justify-content-end chnagebtnrespo">
                <SubmitButtonTwo title={"Change Password"} className="Changebtn"

                />
              </div>
            </div>


          </form>
        </div>

      </div>

    </div>
  );
};

export default ChangePassword;

